<template>
  <div class='h100-40 width-100vw h-scroll'>
    <ejs-grid ref='grid' height='calc(100% - 0px)' :dataSource='data' :contextMenuItems="contextMenuItems" :contextMenuOpen='menuBeforeOpenFunc' :contextMenuClick='menuClickFunc'
      :selectionSettings='selectionOptions' :allowReordering='true' :allowResizing='true' >
      <e-columns>
        <e-column type='checkbox' textAlign='Center' width='66'></e-column>
        <e-column field='notificationRuleName' :headerText='$t("Alarm.rulename")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='notificationType' :headerText='$t("Alarm.notityform")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip' :formatter='noticeTypeFormat'></e-column>
        <e-column field='notificationCycle' :headerText='$t("Alarm.notityinterval")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip' :formatter='noticeCycleFormat'></e-column>
        <e-column field='userGroup' :headerText='$t("Alarm.notifyuser")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        <!--<e-column field='template' :headerText='$t("Alarm.notifytemplate")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip' :formatter='noticeTemplateFormat'></e-column>-->
        <e-column field='enableId' :headerText='$t("Alarm.status")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip' :formatter='noticeStatusFormat'></e-column>
        <e-column field='startDate' :headerText='$t("Alarm.notifystart")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip' type='date' :format='dateFormatOptions'></e-column>
        <e-column field='endDate' :headerText='$t("Alarm.notifyend")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip' type='date' :format='dateFormatOptions'></e-column>
        <e-column field='editTime' :headerText='$t("Alarm.notifyedit")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip' type='date' :format='dateFormatOptions'></e-column>
      </e-columns>
    </ejs-grid>
    <ejs-pager ref='pager' @click='getAlarmNoticeTableData()' :currentPage='page.pageNo' :pageSize='page.pageSize' :totalRecordsCount='page.totalCount' :pageCount='page.pageCount'></ejs-pager>
    <CustomDialog ref='addDialog' :element='addDialogSetting.element' :styles='addDialogSetting.styles'>
      <template v-slot:dialog-content>
        <AddRules ref='addContent'></AddRules>
      </template>
    </CustomDialog>
  </div>
</template>
<script>
import { Reorder, Resize, ContextMenu } from '@syncfusion/ej2-vue-grids';
import CustomDialog from '../../common/CustomDialog';
import AddRules from './AddRules';
import { EventBus } from '../../../plugins/eventBus';

export default {
  name: 'alarmNoticeTable',
  components: {
    CustomDialog,
    AddRules
  },
  data() {
    return {
      selectionOptions: { type: 'Multiple' },
      dateFormatOptions: { type: 'date', format: 'yyyy-MM-dd HH:mm:ss' },
      contextMenuItems: [
        { text: `${this.$t('Alarm.add')}` },
        { text: `${this.$t('Alarm.remove')}` },
        { text: `${this.$t('Alarm.edit')}` },
        { text: `${this.$t('Alarm.refresh')}` },
        { text: `${this.$t('Alarm.able')}` },
        { text: `${this.$t('Alarm.disable')}` }
      ],
      page: {
        pageNo: 1,
        pageSize: 10,
        totalCount: 0,
        pageCount: 10
      },
      queryConditions: {
        systemId: '1'
      },
      data: [],
      addDialogSetting: {
        styles: {
          width: '810px',
          height: '752px',
          model: true,
          visible: false
        },
        element: {
          title: this.$t('Alarm.addRules'),
          refName: 'addRule',
          isClose: true,
          buttonGroup: [
            { click: this.dialogHide, buttonModel: { content: this.$t('Alarm.cancel') } },
            { click: this.addConfirmFunc, buttonModel: { content: this.$t('Alarm.confirm'), isPrimary: true } }
          ]
        }
      }
    };
  },
  provide: {
    grid: [Reorder, Resize, ContextMenu]
  },
  methods: {
    noticeTypeFormat(grids, data) {
      return data.notificationType === 0 ? this.$t('Alarm.notitylevel') : this.$t('Alarm.notityitem');
    },
    noticeCycleFormat(grids, data) {
      return `${data.notificationCycle} ${this.$t(`Alarm.${data.cycleUnit}`)}`;
    },
    noticeTemplateFormat(grids, data) {
      return data.template === 0 ? this.$t('Alarm.notifytemplate1') : this.$t('Alarm.notifytemplate2');
    },
    noticeStatusFormat(grids, data) {
      return data.enableId === 0 ? this.$t('Alarm.able') : this.$t('Alarm.disable');
    },
    menuBeforeOpenFunc(menuArgs) { // 屏蔽表头的右键事件
      if (!menuArgs.rowInfo.rowIndex && menuArgs.rowInfo.rowIndex !== 0) {
        menuArgs.cancel = true;
      }
      const childList = menuArgs.element.querySelectorAll('li.e-menu-item');
      if (this.getCheckedData(true).length > 1) {
        childList[2].style.display = 'none';
      } else {
        childList[2].style.display = 'block';
      }
    },
    menuClickFunc(menuArgs) { // 为右键分配事件
      switch (menuArgs.element.innerText) {
        case `${this.$t('Alarm.add')}`:
          this.addFunc();
          break;
        case `${this.$t('Alarm.remove')}`:
          this.removeFunc();
          break;
        case `${this.$t('Alarm.edit')}`:
          this.editFunc();
          break;
        case `${this.$t('Alarm.refresh')}`:
          this.getAlarmNoticeTableData();
          break;
        case `${this.$t('Alarm.able')}`:
          this.updateStatusFunc('enable');
          break;
        case `${this.$t('Alarm.disable')}`:
          this.updateStatusFunc('unenable');
          break;
        default:
      }
    },
    dialogHide() {
      this.$refs.addDialog.clear();
      this.$refs.addDialog.close();
    },
    getCheckedData(selectOnly) {
      // false: 不支持多选   true: 支持多选
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      if (selectedRecords.length < 1) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('Alarm.no_checked')});
        return false;
      }
      if (selectedRecords.length > 1 && !selectOnly) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('Common.tips.onlyOneSelect')});
        return false;
      }
      return selectedRecords;
    },
    getCheckedVals() {
      const ids = [];
      const checkedData = this.getCheckedData(true);
      for (let i = 0; i < checkedData.length; i++) {
        ids.push(checkedData[i].notificationRuleId);
      }
      return ids;
    },
    getAlarmNoticeTableData() {
      // 获取表格数据
      const This = this;
      This.page.pageNo = This.$refs.pager.ej2Instances.currentPage;
      This.$axios.post('/lte/ems/fm/notification/querybypage', {
        pageNo: This.page.pageNo,
        pageSize: This.page.pageSize
      }).then((response) => {
        const result = response.data.resultVal;
        This.page.totalCount = result.totalCount;
        This.data = result.result;
      });
    },
    addFunc() {
      this.addDialogSetting.element.title = this.$t('Alarm.addRules');
      this.$refs.addDialog.show();
      this.$refs.addContent.clearData();
    },
    addConfirmFunc() {
      const This = this;
      const ruleData = This.$refs.addContent.getAlarmFilterDatas();
      let url = '/lte/ems/fm/notification/addrule';
      if (this.addDialogSetting.element.title !== this.$t('Alarm.addRules')) {
        url = '/lte/ems/fm/notification/updaterule';
      }
      if (ruleData !== false) {
        This.$axios.post(url, ruleData).then((response) => {
          if (response && response.status === 200) {
            This.dialogHide();
            EventBus.$emit('toast', {type: 'success', content: This.$t('Alarm.success')});
            This.getAlarmNoticeTableData();
          } else {
            EventBus.$emit('toast', {type: 'error', content: This.$t('Alarm.error')});
          }
        });
      }
    },
    removeFunc() {
      const This = this;
      const checkedData = This.getCheckedData(true);
      if (checkedData) {
        This.$layer.confirm({
          msg: This.$t('Alarm.alarmDeleteConfirm'),
          btn1: {
            msg: This.$t('Alarm.cancel')
          },
          btn2: {
            msg: This.$t('Alarm.confirm'),
            func: () => {
              This.$axios.post('/lte/ems/fm/notification/delete', This.getCheckedVals()).then((response) => {
                if (response && response.status === 200 && response.data.resultVal === true) {
                  EventBus.$emit('toast', {type: 'success', content: This.$t('Alarm.success')});
                } else {
                  EventBus.$emit('toast', {type: 'error', content: This.$t('Alarm.error')});
                }
                This.getAlarmNoticeTableData();
              });
            }
          }
        });
      }
    },
    editFunc() {
      const This = this;
      This.addDialogSetting.element.title = This.$t('Alarm.editRules');
      const checkedData = This.getCheckedData(false);
      if (checkedData) {
        This.$refs.addDialog.show();
        This.$refs.addContent.clearData();
        This.$refs.addContent.setRuleId(checkedData[0]);
      }
    },
    updateStatusFunc(statusStr) {
      // 禁用 启用
      const This = this;
      const checkedData = This.getCheckedData(true);
      let str = '';
      switch (statusStr) {
        case 'enable':
          str = this.$t('Alarm.enableAlarmNoticeconfirm');
          break;
        case 'unenable':
          str = this.$t('Alarm.unenableAlarmNoticeconfirm');
          break;
        default:
      }
      if (checkedData) {
        this.$layer.confirm({
          msg: `${str}?`,
          btn1: {
            msg: this.$t('Alarm.cancel')
          },
          btn2: {
            msg: this.$t('Alarm.confirm'),
            func: () => {
              This.$axios.post('/lte/ems/fm/notification/updatestatus', {
                status: statusStr,
                ids: This.getCheckedVals()
              }).then((response) => {
                if (response && response.status === 200 && response.data.resultVal === true) {
                  EventBus.$emit('toast', {type: 'success', content: this.$t('Alarm.success')});
                } else {
                  EventBus.$emit('toast', {type: 'error', content: this.$t('Alarm.error')});

                }
                This.getAlarmNoticeTableData();
              });
            }
          }
        });
      }
    }
  },
  mounted() {
    this.getAlarmNoticeTableData();
  }
};
</script>
